/**
 * Each category has an image defined as the key in Cloudinary. The name you can find in
 * the repository where images are stored.
 *
 * https://github.com/photolane/parabo-product-images/tree/master/categories
 */
const PRODUCT_CATEGORIES = [
  {
    id: 'family-history',
    url: '/ancestry-family-history',
    image: 'categories/famhistoryancestry',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['ancestry-book', 'ancestry-poster', 'ancestry-calendar', 'family-flip'],
      },
    ],
  },
  {
    id: 'familysearch',
    url: '/familysearch',
    image: 'categories/familysearch-history',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['familysearch-poster', 'familysearch-calendar', 'familysearch-book',],
      },
    ],
  },
  {
    id: 'family-tree',
    url: '/gedcom-family-tree',
    image: 'categories/famhistorymc',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          // 'family-tree-book',
          'family-tree-poster',
        ],
      },
    ],
  },
  {
    id: 'wall-art',
    url: '/wall-art',
    image: 'categories/wallartmc',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'acrylic-prints',
          'wrapped-canvas-prints',
          'metal-wall-prints',
          'artprint',
          'engineer-prints',
        ],
      },
    ],
  },
  {
    id: 'desk',
    url: '/desk',
    image: 'categories/desk',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'metal-desk-prints',
          // 'desktop-calendar'
        ],
      },
    ],
  },
  {
    id: 'photo-books',
    url: '/photo-books',
    image: 'categories/books',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['softcover-books', 'hardcover-book', 'premium-hardcover-books'],
      },
    ],
  },
  {
    id: 'calendars',
    url: '/calendars',
    image: 'categories/calendars',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'ancestry-calendar',
          'wall-calendar-large',
          // 'desktop-calendar',
          'wall-calendar',
        ],
      },
    ],
  },
  {
    id: 'display',
    url: '/display',
    image: 'categories/displaymc',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'wooden-rails',
          // 'good-hangups',
          // 'skeleton-clips',
        ],
      },
    ],
  },
  {
    id: 'magnets',
    url: '/magnets',
    image: 'categories/magnets',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['acrylic-magnets', 'photobooth-magnets'],
      },
    ],
  },
  {
    id: 'photo-prints',
    url: '/photo-prints',
    image: 'categories/magnets',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'glossy-prints',
          'metal-desk-prints',
          'acrylic-magnets',
          'photobooth-magnets',
        ],
      },
    ],
  },
];

export default PRODUCT_CATEGORIES;
